export const useScrollToElement = () => {
	const scrollToElementByName = (elementName: string) => {
		const elements = document.getElementsByName(elementName);

		if (elements.length > 0) {
			elements[0]?.scrollIntoView({ behavior: 'smooth', block: 'center' });
			elements[0]?.focus();
		}
	};

	return {
		scrollToElementByName
	};
};
